import React from 'react';
import Logo from 'components/Logo/Logo';
import Restaurants from './Restaurants/Restaurants';
import Aux from '../../../hoc/ReactAux/ReactAux';
import './SideBar.css';

const sideBar = props => {
  return (
    <div
      className={
        props.showMenuMobile ? 'principal-left menu-open' : 'principal-left'
      }
      aria-label="Left Menu, restaurants list"
      tabIndex={1}
    >
      <div
        className={
          props.showRestaurantsMobile ? 'menu-left menu-open' : 'menu-left'
        }
      >
        <button
          title="Close (Esc)"
          type="button"
          className="btn-close"
          aria-describedby="Close modal button"
          onClick={() => props.toggleMenuMobile()}
        ></button>
        <Logo goToMenu={props.goToDefaultMenu} />
        <nav className="menu-nav" aria-label="Restaurants list">
          <ul>
            {props.itemsSideBarMenu.map((item, index) => {
              return (
                <Aux key={item.index}>
                  {item.restaurants ? (
                    <Aux>
                      <li
                        onClick={() => props.selectItemSideBar(item.index)}
                        className={item.active ? 'active' : null}
                        role="button"
                        aria-expanded={item.active ? 'true' : 'false'}
                      >
                        <i className={item.class} aria-hidden="true"></i>
                        <b className="xfirst-item">
                          <a aria-label={item.title}>{item.title}</a>
                        </b>
                        <i className="d-arrow" aria-hidden="true"></i>
                      </li>
                      <ul
                        aria-label="Restaurants List"
                        className={item.active ? 'submenu' : 'submenu-hide'}
                      >
                        {item.restaurants.businessDelivery ? (
                          <Restaurants
                            activeItem={props.activeRestaurant}
                            selectRestaurantItem={
                              props.selectRestaurantDelivery
                            }
                            toggleMenuMobile={props.toggleMenuMobile}
                            items={
                              props.restaurantsOptions[0].active
                                ? item.restaurants.businessDelivery
                                : item.restaurants.businessCollection
                            }
                          />
                        ) : (
                          <Restaurants
                            activeItem={props.activeRestaurant}
                            selectRestaurantItem={props.selectRestaurantPlatter}
                            toggleMenuMobile={props.toggleMenuMobile}
                            items={item.restaurants.businessPlatter}
                          />
                        )}
                      </ul>
                    </Aux>
                  ) : (
                    <li
                      onClick={() => props.selectItemSideBar(item.index)}
                      className={item.active ? 'active' : null}
                    >
                      <i className={item.class} aria-hidden="true"></i>
                      <a aria-label={item.title}>
                        <b>{item.title}</b>
                      </a>
                    </li>
                  )}
                </Aux>
              );
            })}
          </ul>
        </nav>
      </div>
      <div className="cart-menu-category-overlay"></div>
    </div>
  );
};

export default sideBar;



// WEBPACK FOOTER //
// ./src/containers/Menu/SideBar/SideBar.js